import { Injectable } from '@angular/core';

@Injectable()
export class SessionStorageService {
  setData(key: string, payload: unknown): void {
    const stringPayload = JSON.stringify(payload);
    sessionStorage.setItem(key, stringPayload);
  }

  getData<T>(key: string): T {
    const storageData = sessionStorage.getItem(key) as string;
    return JSON.parse(storageData);
  }
}
